export const EDIT_MODAL_TOGGLE = 'ctgr/user/edit_modal_toggle';
export const ADD_CITATIONS_TO_SEARCH_RESULT = 'ctgr/system/add_citations_to_search_result';
export const USER_CHANGED_CITATION_STYLE = 'ctgr/user/changed_citation_style';
export const ADD_CITATION_TO_LIST = 'ctgr/user/add_citaion_to_list';
export const ADD_CITATIONS_TO_LIST = 'ctgr/user/add_citaions_to_list';
export const REMOVE_CITATION_FROM_LIST = 'ctgr/user/remove_citaion_from_list';
export const CHANGED_CITATION_SOURCE = 'ctgr/user/changed_citation_source';
export const USER_SEARCHED_QUERY = 'ctgr/user/searched_query';
export const USER_SEARCHED_IN_CITATION_LIST = 'ctgr/user/searched_in_citation_list';
export const USER_CLICKED_COMPOSE_NEW_CITATION = 'ctgr/user/clicked_compose_new_citation';
export const USER_CLICKED_ADD_CITATION = 'ctgr/user/clicked_add_citation';
export const USER_CLICKED_BACK_BUTTON = 'ctgr/user/clicked_back_button';
export const USER_CLOSED_PREVIEW_MODAL = 'ctgr/user/closed_preview_modal';
export const USER_CLICKED_DELETE_CITATION = 'ctgr/user/clicked_delete_citation';
export const USER_CLICKED_EDIT_CITATION = 'ctgr/user/clicked_edit_citation';
export const USER_CLICKED_CLONE_CITATION = 'ctgr/user/clicked_clone_citation';
export const USER_CLICKED_OPEN_SOURCE = 'ctgr/user/clicked_open_source';
export const USER_CLICKED_EXPORT_TO_DOC = 'ctgr/user/clicked_export_to_doc';
export const USER_CLICKED_EXPORT_BUTTON = 'ctgr/user/clicked_export_button';
export const USER_CLICKED_COPY_SINGLE_FULL_TEXT_CITATION =
  'ctgr/user/clicked_copy_single_full_text_citation_button';
export const USER_CLICKED_COPY_SINGLE_IN_TEXT_CITATION_BUTTON =
  'ctgr/user/clicked_copy_single_in_text_citation_button';
export const USER_CLICKED_COPY_ALL_FULL_TEXT_CITATIONS_BUTTON =
  'ctgr/user/clicked_copy_all_full_text_citations_button';
export const USER_CLICKED_COPY_BUTTON = 'ctgr/user/clicked_copy_button';
export const SetSearchQuery = 'ctgr/user/SetSearchQuery';
export const RemoveAllCitaionList = 'ctgr/user/RemoveAllCitaionList';
export const SetLoadingResults = 'ctgr/user/SetLoadingResults';
export const IncrementPageNo = 'ctgr/user/IncrementPageNo';
export const SetIsLastPage = 'ctgr/user/SetIsLastPage';
export const RestoreToDefaultState = 'ctgr/user/RestoreToDefaultState';
export const IgnoreWarning = 'ctgr/user/IgnoreWarning';
export const OpenInplaceCreateForm = 'ctgr/user/InplaceCreateFormOpenedFromCowriter';
export const SetCitedData = 'ctgr/system/SetCitedData';
export const UpdateCitedData = 'ctgr/system/UpdateCitedData';
export const AddClonedCitedData = 'ctgr/system/AddClonedCitedData';
export const RemoveCitedData = 'ctgr/system/RemoveCitedData';
export const SetCitationStyles = 'ctgr/system/SetCitationStyles';
export const RebuildCitationNumbers = 'ctgr/system/RebuildCitationNumbers';
export const StartSearchMode = 'ctgr/system/StartSearchMode';
export const StopSearchMode = 'ctgr/system/StopSearchMode';

export enum TriggeringActions {
  DELETE_ALL = 'Delete All',
  DELETE_ONE = 'Delete One',
  SAVE_BUTTON = 'Save Button',
  CITE_BUTTON = 'Cite Button',
  SEARCH_RESULT = 'Search Result',
  ADDED_CITATIONS = 'Added Citations',
  EXPORT_ALL_BUTTON = 'Export All Button',
  EXPORT_TO_DOC_BUTTON = 'Export To Doc Button',
  PREVIEW_MODAL = 'Preview Modal',
  IN_TEXT_PREVIEW_MODAL = 'In-text Preview Modal',
  EDIT_FORM = 'Edit Form',
  CITATION_HEADER = 'Citation Header',
}
